import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-alert-dismiss': {
    'ar-AE': 'تجاهل',
    'bn-IN': 'বাতিল করুন',
    'cs-CZ': 'zavřít',
    'da-DK': 'afvis',
    'de-DE': 'verwerfen',
    'en-US': 'dismiss',
    'es-CL': 'descartar',
    'es-CO': 'descartar',
    'es-ES': 'descartar',
    'es-MX': 'descartar',
    'es-US': 'descartar',
    'fr-BE': 'ignorer',
    'fr-CA': 'rejeter',
    'fr-FR': 'ignorer',
    'he-IL': 'ביטול',
    'hi-IN': 'बंद करें',
    'it-IT': 'chiudi',
    'ja-JP': '閉じる',
    'kn-IN': 'ವಜಾಗೊಳಿಸಿ',
    'ko-KR': '닫기',
    'ml-IN': 'നിരസിക്കുക',
    'mr-IN': 'रद्द करा',
    'nl-BE': 'sluiten',
    'nl-NL': 'negeren',
    'pl-PL': 'odrzuć',
    'pt-BR': 'ignorar',
    'pt-PT': 'ignorar',
    'sv-SE': 'stäng',
    'ta-IN': 'மூடுக',
    'te-IN': 'విస్మరించండి',
    'tr-TR': 'reddet',
    'zh-CN': '忽略',
    'zh-TW': '關閉',
  },
};

export default katTranslator(strings);
